export enum BillingsOrderForwardTaxiTaxiAddRequestContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  CHARGE_HIGHWAYS = "CHARGE_HIGHWAY",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsOrderForwardTaxiTaxiAddRequestBonusContributionFavorableDistance =
  {
    type: BillingsOrderForwardTaxiTaxiAddRequestContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsOrderForwardTaxiTaxiAddRequestBonusContributionOther = {
  type: BillingsOrderForwardTaxiTaxiAddRequestContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionWrongRoute =
  {
    type: BillingsOrderForwardTaxiTaxiAddRequestContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionBeingLate =
  {
    type: BillingsOrderForwardTaxiTaxiAddRequestContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionIncompatibleCar =
  {
    type: BillingsOrderForwardTaxiTaxiAddRequestContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionOther = {
  type: BillingsOrderForwardTaxiTaxiAddRequestContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsOrderForwardTaxiTaxiAddRequestBonusContribution =
  | BillingsOrderForwardTaxiTaxiAddRequestBonusContributionFavorableDistance
  | BillingsOrderForwardTaxiTaxiAddRequestBonusContributionOther;

export type BillingsOrderForwardTaxiTaxiAddRequestPenaltyContribution =
  | BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionWrongRoute
  | BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionBeingLate
  | BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionIncompatibleCar
  | BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionOther;

export type BillingsOrderForwardTaxiTaxiAddRequestContribution =
  | BillingsOrderForwardTaxiTaxiAddRequestBonusContribution
  | BillingsOrderForwardTaxiTaxiAddRequestPenaltyContribution;

export type BillingsOrderForwardTaxiTaxiAddRequestBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventId: string | null;
  plannedDate: Date | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsOrderForwardTaxiTaxiAddRequestBody = {
  billingNodes: BillingsOrderForwardTaxiTaxiAddRequestBillingNode[];
  billingContributions: BillingsOrderForwardTaxiTaxiAddRequestContribution[];
};

type BillingsOrderForwardTaxiTaxiAddRequest = {
  forwardingId: string;
  billingNodes: BillingsOrderForwardTaxiTaxiAddRequestBillingNode[];
  billingContributions: BillingsOrderForwardTaxiTaxiAddRequestContribution[];
};

export default BillingsOrderForwardTaxiTaxiAddRequest;
